import Footer from "../ones/Footer";
import HomeAboutSection from "../ones/HomeAboutSection";
import HomeBanner1 from "../ones/HomeBanner1";
import HomeServicesContent from "../ones/HomeServicesContent";

export default function HomeLanding() {
  return (
    <>
      <HomeBanner1 />
      <HomeServicesContent />
      <HomeAboutSection />
      <Footer />
    </>
  );
}
